import _ from 'lodash';
import React from 'react';

import {
    Text
} from 'recharts';

// This is a custom x-axis tick that indents the first and last tick in and sets our custom fill/fontSize; otherwise, it's the exact tick that recharts uses.
export default function XAxisTick(props) {
    const textProps = _.defaults({
        fill: '#4c535e',
        fontSize: '12px'
    }, props);

    if (props.indent !== false) {
        if (props.index === 0) {
            textProps.textAnchor = 'start';
        } else if (props.index === props.visibleTicksCount - 1) {
            textProps.textAnchor = 'end';
        }
    }

    const formattedValue = props.tickFormatter(props.payload.value, props.index);
    return (
        <Text {...textProps}>
            {formattedValue}
        </Text>
    );
}
